import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Button from '@/components/ui/Button';
import Logo from '@/components/branding/Logo';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-cream via-cream-warm to-cream-light relative overflow-hidden flex flex-col">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[15%] left-[18%] w-56 h-56 lg:w-80 lg:h-80 rounded-full bg-primary/[0.05] animate-[float_8s_ease-in-out_infinite]" />
        <div className="absolute bottom-[12%] right-[15%] w-64 h-64 lg:w-96 lg:h-96 rounded-full bg-primary/[0.04] animate-[float_10s_ease-in-out_infinite_1s]" />
        <div className="absolute top-[55%] left-[55%] w-32 h-32 lg:w-56 lg:h-56 rounded-full bg-primary/[0.05] animate-[float_9s_ease-in-out_infinite_0.5s]" />
      </div>

      <div className="flex-1 flex flex-col items-center justify-center max-w-2xl mx-auto w-full px-6 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <Logo variant="stacked" size="lg" />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.05 }}
          className="font-sans text-xs uppercase tracking-[0.24em] text-text-muted mb-4"
        >
          404
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, delay: 0.05 }}
          className="w-full font-display italic font-light text-5xl md:text-7xl leading-[1.05] text-text-primary mb-5"
        >
          Lost your way?
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="font-sans text-base md:text-lg text-text-secondary mb-10"
        >
          We couldn't find that page. Let's get you back to practicing.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.25 }}
          className="w-full max-w-xs"
        >
          <Button fullWidth onClick={() => navigate('/', { replace: true })}>
            Take me home
          </Button>
        </motion.div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-20px) scale(1.05); }
        }
      `}</style>
    </div>
  );
}
